import { handleJsonResponse, requestGet, SERVICE_URL } from 'util/request';

import { TimingsResponse } from './types';

export const requestGetTimings = async (): Promise<TimingsResponse> =>
  handleJsonResponse(await requestGet(`${SERVICE_URL}/sampling_timings/`));
